import { fetchFromApi, optionsForFileRequest } from './apiUtils';

const basePath = '/v1/blackbox';

const blackboxUpload = payload =>
  fetchFromApi(`${basePath}/upload`, optionsForFileRequest(payload));

export default { blackboxUpload };
